export const loadScript = (src, cb) => { // eslint-disable-line import/prefer-default-export
    const script = document.createElement('script');
    const head = document.querySelector('head');
    script.src = src;
    script.onload = cb;
    head.appendChild(script);
};
